/* eslint-disable */
transkey_surl = `${process.env.VUE_APP_API_URL}transkeyServlet`;
tk_origin = `&origin=${process.env.VUE_APP_ORIGIN}`

const scripts = [
  "/raon/transkey_mobile/transkey.js",
  "/raon/transkey_mobile/rsa_oaep_files/rsa_oaep-min.js",
  "/raon/transkey_mobile/jsbn/jsbn-min2.js",
  "/raon/transkey_mobile/TranskeyLibPack_op.js",
  "/raon/transkey_mobile/typedarray.js",
  `${process.env.VUE_APP_API_URL}transkeyServlet?op=getToken&${(new Date()).getTime()}&origin=${process.env.VUE_APP_ORIGIN}`,
  `${process.env.VUE_APP_API_URL}transkeyServlet?op=getInitTime&origin=${process.env.VUE_APP_ORIGIN}`
];

const css = ["/raon/transkey_mobile/transkey.css"];
const length = scripts.length;

//eslint-disable-next-line no-unused-vars
export function importJS(a, id) {
  const script = scripts.shift();
  if (script !== undefined) {
    const n = document.createElement("script");
    n.src = script;
    n.onload = function() {
      a++;
      if (length > a) {
        importJS(a, id);
      } else {
        window.initmTranskey();
        let input;
        for (let i = 0; i < id.length; i++) {
          input = document.getElementById(id[i]);
          input.disabled = false;
        }
      }
      // length > a ? importJS(a) : window.initmTranskey()
    };
    document.head.appendChild(n);
  } else {
    removeMtk();
    window.initmTranskey();
    let input;
    for (let i = 0; i < id.length; i++) {
      input = document.getElementById(id[i]);
      input.disabled = false;
    }
  }
}
// eslint-disable-next-line no-unused-vars
export function importCSS() {
  const script = css.shift();
  if (script !== undefined) {
    const n = document.createElement("link");
    n.rel = "stylesheet";
    n.href = script;
    n.onload = function() {
      importCSS();
    };
    document.head.appendChild(n);
  }
}

// eslint-disable-next-line no-unused-vars
export function removeMtk() {
  // eslint-disable-next-line no-undef
  for (let i = 0; i < transkey.objs.length; i++) {
    // eslint-disable-next-line no-undef
    mtk.remove(transkey[transkey.objs[i]].inputObj);
  }
  // eslint-disable-next-line no-undef
  transkey.objs.length = 0;
}
  
